document.addEventListener('DOMContentLoaded', () => {

   const clienteSelect = document.getElementById('filter-cliente');
   const regiaoSelect = document.getElementById('filter-regiao');
   const tipoSelect = document.getElementById('filter-tipo');
   const resetButton = document.getElementById('filter-reset');
   const grid = document.querySelector('.clients .grid');
   const pagination = document.querySelector('[data-clients-pagination]');
   const loadMoreButton = pagination?.querySelector('[data-load-more]');

   if (!clienteSelect || !regiaoSelect || !tipoSelect || !resetButton || !grid) {
      return;
   }

   const perPageRaw = parseInt(grid.dataset.length, 10);
   const perPage = perPageRaw > 0 ? perPageRaw : 12;
   const hasLoadMore = grid.dataset.loadMore === 'true' && pagination && loadMoreButton;

   let pivot = null;
   let currentFilters = {};
   let activeVersion = 0;
   let paginationState = {
      page: 1,
      totalPages: 0,
      totalItems: 0,
      loading: false
   };

   const originalOptions = {
      cliente: [...clienteSelect.options],
      regiao: [...regiaoSelect.options],
      tipo: [...tipoSelect.options]
   };

   function normalizeResponse(data) {

      if (Array.isArray(data)) {
         return {
            items: data,
            pagination: {
               page: 1,
               total_pages: data.length ? 1 : 0,
               total_items: data.length
            }
         };
      }

      return {
         items: data.items || [],
         pagination: data.pagination || {
            page: 1,
            total_pages: 0,
            total_items: 0
         }
      };

   }

   function getFilters() {

      const filters = {};

      if (clienteSelect.value) filters.id = clienteSelect.value;
      if (tipoSelect.value) filters.tipo = tipoSelect.value;
      if (regiaoSelect.value) filters.regiao = regiaoSelect.value;

      return filters;

   }

   function buildQuery(filters = {}, options = {}) {

      const params = new URLSearchParams();

      params.set('per_page', options.all ? '-1' : String(perPage));

      if (!options.all) {
         params.set('page', String(options.page || 1));
      }

      if (options.context) {
         params.set('context', options.context);
      }

      if (options.includeImage === false) {
         params.set('include_image', '0');
      }

      Object.entries(filters).forEach(([key, value]) => {
         if (value) {
            params.set(key, value);
         }
      });

      return params.toString();

   }

   function rebuildSelect(select, options) {

      const value = select.value;

      select.innerHTML = '';

      options.forEach(opt => {

         const clone = opt.cloneNode(true);

         if (clone.value === value) clone.selected = true;

         select.appendChild(clone);

      });

   }

   function disableSelect(select) {
      select.classList.add('is-disabled');
   }

   function enableSelect(select) {
      select.classList.remove('is-disabled');
   }

   function setLoadMoreState({ hidden = false, loading = false } = {}) {

      if (!hasLoadMore) {
         return;
      }

      pagination.classList.toggle('d-none', hidden);
      loadMoreButton.disabled = loading;

      if (loading) {
         loadMoreButton.textContent = 'Carregando...';
      }

   }

   function updatePagination(meta = {}) {

      paginationState = {
         ...paginationState,
         page: Number(meta.page) || 1,
         totalPages: Number(meta.total_pages) || 0,
         totalItems: Number(meta.total_items) || 0,
         loading: false
      };

      if (!hasLoadMore) {
         return;
      }

      const hasItems = paginationState.totalItems > 0;
      const hasNextPage = paginationState.page < paginationState.totalPages;

      if (!hasItems || !hasNextPage) {
         setLoadMoreState({ hidden: true });
         return;
      }

      loadMoreButton.textContent = `Carregar ${paginationState.page + 1} de ${paginationState.totalPages}`;
      setLoadMoreState({ hidden: false });

   }

   async function fetchClientes(filters = {}, options = {}) {

      const query = buildQuery(filters, options);
      const url = `/wp-json/hersil/v1/clientes?${query}`;
      const res = await fetch(url);

      if (!res.ok) throw new Error('Erro ao buscar clientes');

      const data = await res.json();

      return normalizeResponse(data);

   }

   async function fetchFilterPosts(filters = {}) {

      return fetchClientes(filters, {
         all: true,
         context: 'filters',
         includeImage: false
      });

   }

   function renderPosts(posts, append = false) {

      if (!append) {
         grid.innerHTML = '';
      }

      if (!posts.length && !append) {
         grid.innerHTML = '<p>Nenhum cliente encontrado.</p>';
         return;
      }

      posts.forEach(post => {

         const img = post.image || '';
         const title = post.title || '';
         const id = post.id || '';

         const html = `
      <div class="item" data-id="${id}">
         ${img ? `<img src="${img}" alt="${title}" class="img-fluid" />` : ''}
         <div class="info">
            <h3 class="name">${title}</h3>
            <img src="/wp-content/themes/custom-theme/assets/img/icon/arrow-top-right.svg" />
         </div>
      </div>
      `;

         grid.insertAdjacentHTML('beforeend', html);

      });

   }

   function filterSelectOptions(posts, select, key) {

      const allowed = new Set(posts.map(p => String(p[key])));

      const options = originalOptions[select.id.replace('filter-', '')];

      const value = select.value;

      select.innerHTML = '';

      options.forEach(opt => {

         const clone = opt.cloneNode(true);

         if (clone.value === value) {
            clone.selected = true;
         }

         if (clone.value && !allowed.has(clone.value)) {
            clone.disabled = true;
            clone.style.opacity = "0.5";
         }

         select.appendChild(clone);

      });

   }

   async function loadGridPage(page = 1, append = false) {

      const version = activeVersion;

      if (append) {
         paginationState.loading = true;
         setLoadMoreState({ hidden: false, loading: true });
      }

      const { items, pagination: meta } = await fetchClientes(currentFilters, { page });

      if (version !== activeVersion) {
         return null;
      }

      renderPosts(items, append);
      updatePagination(meta);

      return { items, pagination: meta };

   }

   async function handleFilterChange() {

      activeVersion += 1;

      const version = activeVersion;
      const clienteID = clienteSelect.value;
      const regiaoID = regiaoSelect.value;
      const tipoID = tipoSelect.value;

      currentFilters = getFilters();

      let pivotFilters = {};

      setLoadMoreState({ hidden: true });

      if (pivot === 'tipo' && tipoID) {
         pivotFilters = { tipo: tipoID };
      }

      if (pivot === 'regiao' && regiaoID) {
         pivotFilters = { regiao: regiaoID };
      }

      try {

         const response = await loadGridPage(1);

         if (!response || version !== activeVersion) {
            return;
         }

         if (clienteID) {
            return;
         }

         let pivotPosts = response.items;

         if (pivot === 'tipo' || pivot === 'regiao') {
            const filtersResponse = await fetchFilterPosts(pivotFilters);

            if (version !== activeVersion) {
               return;
            }

            pivotPosts = filtersResponse.items;
         }

         if (pivot === 'tipo') {

            rebuildSelect(tipoSelect, originalOptions.tipo);

            filterSelectOptions(pivotPosts, clienteSelect, 'id');
            filterSelectOptions(pivotPosts, regiaoSelect, 'regiao');

         }

         else if (pivot === 'regiao') {

            rebuildSelect(regiaoSelect, originalOptions.regiao);

            filterSelectOptions(pivotPosts, clienteSelect, 'id');
            filterSelectOptions(pivotPosts, tipoSelect, 'tipo');

         }

      }
      catch (e) {

         console.error(e);
         grid.innerHTML = '<p>Erro ao carregar clientes.</p>';
         setLoadMoreState({ hidden: true });

      }

   }

   clienteSelect.addEventListener('change', () => {

      pivot = 'cliente';

      if (clienteSelect.value) {

         regiaoSelect.value = '';
         tipoSelect.value = '';

         disableSelect(regiaoSelect);
         disableSelect(tipoSelect);

      }
      else {

         enableSelect(regiaoSelect);
         enableSelect(tipoSelect);

      }

      resetButton.classList.remove('d-none');

      handleFilterChange();

   });

   tipoSelect.addEventListener('change', () => {

      if (!pivot) pivot = 'tipo';

      resetButton.classList.remove('d-none');

      handleFilterChange();

   });

   regiaoSelect.addEventListener('change', () => {

      if (!pivot) pivot = 'regiao';

      resetButton.classList.remove('d-none');

      handleFilterChange();

   });

   resetButton.addEventListener('click', async () => {

      pivot = null;

      clienteSelect.value = '';
      regiaoSelect.value = '';
      tipoSelect.value = '';

      rebuildSelect(clienteSelect, originalOptions.cliente);
      rebuildSelect(regiaoSelect, originalOptions.regiao);
      rebuildSelect(tipoSelect, originalOptions.tipo);

      enableSelect(clienteSelect);
      enableSelect(regiaoSelect);
      enableSelect(tipoSelect);

      resetButton.classList.add('d-none');

      currentFilters = {};

      try {
         activeVersion += 1;
         await loadGridPage(1);
      }
      catch (error) {
         console.error(error);
         grid.innerHTML = '<p>Erro ao carregar clientes.</p>';
         setLoadMoreState({ hidden: true });
      }

   });

   loadMoreButton?.addEventListener('click', async () => {

      if (paginationState.loading || paginationState.page >= paginationState.totalPages) {
         return;
      }

      try {
         await loadGridPage(paginationState.page + 1, true);
      }
      catch (error) {
         console.error(error);
         setLoadMoreState({ hidden: false });
      }

   });

   handleFilterChange();

});
